import React, { useEffect, useState } from 'react'
import './dataTablePartnerReward.scss'
import { DataGrid } from '@mui/x-data-grid';
import { engagmentAnalysisColumns } from '../../data/dataSource';
import { Link } from 'react-router-dom';
import { collection, getDocs,  deleteDoc, doc, onSnapshot, query, orderBy, where, updateDoc } from "firebase/firestore";
import { db, auth } from '../../firebase'
import ConfirmBox from '../ConfirmBox';
import { deleteUser, getAuth } from 'firebase/auth';

const DataTable = () => {

  const [ data, setData ] = useState([])

  const [ isLoading, setIsLoading ] = useState(true)
  
  const [open, setOpen] = useState(false);

 
 
  const Spinner = () => {
    return(
      <div className='spinner-container'>
          <div className='loading-spinner'></div>
      </div>
    )
  }
  
 

  useEffect(() => {

//LISTEN REAL TIME

    const unsub = onSnapshot(collection(db, "standardWhatsappMessages"), (snapShot) => {
      let list = [];
      snapShot.docs.forEach((doc) => {
        list.push({ id: doc.id, ...doc.data()})
      })
      setData(list)
      setIsLoading(false)
    }, 
      (error) => {
        console.log(error)
      }
    );

    return () => {
      unsub();
    }

  },[])

  console.log(data)




//   function openDelete(id) {
//         setOpen(true);
//         setAdminId(id);

//   }
  
    console.log(data)


  const actionColumn = [

    { field: 'action', headerName: 'Action', width: 100, 
    
            renderCell:(params) => {
                return(
                    <div className='cellAction'>
                       <Link to={`/standardmessages/${params.row.id}`} style={{textDecoration:"none"}}>
                          <div className="viewbutton">View</div>
                       </Link>

                    </div>
                )
            }
    }
      
  ]  

  return (

    <>

       <div className="datatable">
      <div className='datatableTitle'>
        All Standard Whatsapp Analysis
        <div style={{display: 'flex', flexDirection:'row', gap:"10px"}}>
            {/* <Link to="/standardmessages/new"  style={{textDecoration:"none"}} >
              <div className='link'>
                Add New Standard Messages
              </div>
            </Link> */}

        </div>
      
      </div>
      {isLoading 
      ? <Spinner/>
      :<DataGrid
          className="userTableGrid"
          style={{height:1200}}
          rows={data}
          columns={engagmentAnalysisColumns.concat(actionColumn)}
          pageSize={40}
          rowsPerPageOptions={[40]}
          checkboxSelection
        />
      }
    </div>
    

    </>

   
  )
}

export default DataTable